export enum BootKeys {
    TranscriptAssociated = "TranscriptAssociated",
    AudioBackupState = "AudioBackupState",
    DurationSeconds = "DurationSeconds",
    IsFreemiumUpsellEnabled = "IsFreemiumUpsellEnabled",
    IsLicensedUser = "IsLicensedUser",
    TranscriptionSessionId = "TranscriptionSessionId",
    TranscriptionPaneBuildNumber = "TranscriptionPaneBuildNumber",
    DidBootFinishSuccessfully = "DidBootFinishSuccessfully", 

    // Durations for asynchronous tasks
    LoadTranscriptionStringsDuration = "LoadTranscriptionStringsDuration",
    InitializeBackupStateDuration = "InitializeBackupStateDuration",
    SetInitialPageFromBackupStateAndStoredTranscriptionDuration = "SetInitialPageFromBackupStateAndStoredTranscriptionDuration",

    // Durations for sequential boot stages
    InitializeBootStageDuration = "InitializeBootStageDuration",
    InitializeAsyncTasksStageDuration = "InitializeAsyncTasksStageDuration",
    ExecuteSynchronousTasksStageDuration = "ExecuteSynchronousTasksStageDuration",
    WaitForAsyncTasksStageDuration = "WaitForAsyncTasksStageDuration",
    FinalizeBootStageDuration = "FinalizeBootStageDuration",
};